
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {TasinmazHaczininKaldirilmasiTalep} from "@/interface/IUyapTalep";
import Dates from "@/components/inputs/Dates.vue";

@Component({
  components: {Dates}
})
export default class TasinmazHaczininKaldirilmasiTalepEvrakForm extends Mixins(ObjectInputMixin) {
  localValue!: TasinmazHaczininKaldirilmasiTalep;
}
